import Cookies from "js-cookie";

import {UserAccount, UserAccounts} from "./types";

const oauthSessionKey = "oauth-session-id";
const oauthRedirectUriKey = "oauth-redirect-uri";
const pendingOAuthCookieKey = "wk_pending_oauth";
const pendingOAuthCookieLifetimeDays = 1 / 24;

type PendingOAuthContext = {
  sessionId?: string
  redirectUri?: string
}

export const OAuthStore = {
  setSession(sessionId: string): void {
    sessionStorage.setItem(oauthSessionKey, sessionId);
    setPendingOAuthContext({sessionId});
  },
  getSession(): string | null {
    const pendingContext = getPendingOAuthContext();
    if (pendingContext?.sessionId) {
      sessionStorage.setItem(oauthSessionKey, pendingContext.sessionId);
      return pendingContext.sessionId;
    }
    return sessionStorage.getItem(oauthSessionKey);
  },
  clear: (): void => {
    sessionStorage.removeItem(oauthSessionKey);
    sessionStorage.removeItem(oauthRedirectUriKey);
    Cookies.remove(pendingOAuthCookieKey, {path: "/"});
  },
  setRedirectUri(redirectUri: string): void {
    sessionStorage.setItem(oauthRedirectUriKey, redirectUri);
    setPendingOAuthContext({redirectUri});
  },
  getRedirectUri(): string {
    const pendingContext = getPendingOAuthContext();
    if (pendingContext?.redirectUri) {
      sessionStorage.setItem(oauthRedirectUriKey, pendingContext.redirectUri);
      return pendingContext.redirectUri;
    }
    return sessionStorage.getItem(oauthRedirectUriKey) || "";
  }
}

const setPendingOAuthContext = (update: PendingOAuthContext): void => {
  const current = getPendingOAuthContext() || {};
  const next = {
    ...current,
    ...update,
  };
  if (!next.sessionId && !next.redirectUri) {
    Cookies.remove(pendingOAuthCookieKey, {path: "/"});
    return;
  }
  Cookies.set(pendingOAuthCookieKey, JSON.stringify(next), {
    expires: pendingOAuthCookieLifetimeDays,
    path: "/",
    sameSite: "Lax",
    secure: window.location.protocol === "https:",
  });
};

const getPendingOAuthContext = (): PendingOAuthContext | null => {
  const pendingContext = Cookies.get(pendingOAuthCookieKey);
  if (!pendingContext) {
    return null;
  }
  try {
    const parsed = JSON.parse(pendingContext) as PendingOAuthContext;
    if (!parsed.sessionId && !parsed.redirectUri) {
      Cookies.remove(pendingOAuthCookieKey, {path: "/"});
      return null;
    }
    return parsed;
  } catch {
    Cookies.remove(pendingOAuthCookieKey, {path: "/"});
    return null;
  }
};

export const UserAccountStore = {
  clear() {
    localStorage.removeItem("accounts");
  },
  get(): UserAccounts {
    const accounts = localStorage.getItem("accounts");
    if (!accounts) {
      return new UserAccounts([]);
    }
    const userAccounts: UserAccount[] = JSON.parse(accounts);
    return new UserAccounts(userAccounts);
  },
  set(userAccounts: UserAccounts) {
    const accounts = userAccounts.list();
    localStorage.setItem("accounts", JSON.stringify(accounts));
    return
  },
}
